import { render, staticRenderFns } from "./RadioClass.vue?vue&type=template&id=40406cca&scoped=true&lang=pug"
import script from "./RadioClass.vue?vue&type=script&lang=js"
export * from "./RadioClass.vue?vue&type=script&lang=js"
import style0 from "./RadioClass.vue?vue&type=style&index=0&id=40406cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40406cca",
  null
  
)

export default component.exports